import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  elementAuditableNorme: {
    selectedNorme: {
      id: "",
      code: "",
      value: ""
    },
    searchTerm: "",
    elementsDisponibles: [],
    elementsAssocies: [],
    selectedDisponibles: [],
    selectedAssocies: [],
    paginationModel: {
      page: 0,
      pageSize: 10
    }
  }
};

const auditsInspectionsSlice = createSlice({
  name: 'auditsInspections',
  initialState,
  reducers: {
    setSelectedNorme: (state, action) => {
      state.elementAuditableNorme.selectedNorme = action.payload;
    },
    setSearchTerm: (state, action) => {
      state.elementAuditableNorme.searchTerm = action.payload;
    },
    setElementsDisponibles: (state, action) => {
      state.elementAuditableNorme.elementsDisponibles = action.payload;
    },
    setElementsAssocies: (state, action) => {
      state.elementAuditableNorme.elementsAssocies = action.payload;
    },
    setSelectedDisponibles: (state, action) => {
      state.elementAuditableNorme.selectedDisponibles = action.payload;
    },
    setSelectedAssocies: (state, action) => {
      state.elementAuditableNorme.selectedAssocies = action.payload;
    },
    setPaginationModel: (state, action) => {
      state.elementAuditableNorme.paginationModel = action.payload;
    },
    moveElementsToAssocies: (state, action) => {
      const idsToMove = action.payload;
      const elementsToMove = state.elementAuditableNorme.elementsDisponibles.filter(
        elem => idsToMove.includes(elem.id)
      );
      
      state.elementAuditableNorme.elementsAssocies = [
        ...state.elementAuditableNorme.elementsAssocies,
        ...elementsToMove
      ];
      
      state.elementAuditableNorme.elementsDisponibles = 
        state.elementAuditableNorme.elementsDisponibles.filter(
          elem => !idsToMove.includes(elem.id)
        );
      
      state.elementAuditableNorme.selectedDisponibles = [];
    },
    moveElementToDisponibles: (state, action) => {
      const idToMove = action.payload;
      const elementToMove = state.elementAuditableNorme.elementsAssocies.find(
        elem => elem.id === idToMove
      );
      
      if (elementToMove) {
        state.elementAuditableNorme.elementsDisponibles = [
          ...state.elementAuditableNorme.elementsDisponibles,
          elementToMove
        ];
        
        state.elementAuditableNorme.elementsAssocies = 
          state.elementAuditableNorme.elementsAssocies.filter(
            elem => elem.id !== idToMove
          );
      }
    },
    resetSelections: (state) => {
      state.elementAuditableNorme.selectedDisponibles = [];
      state.elementAuditableNorme.selectedAssocies = [];
    },
    clearSearchTerm: (state) => {
      state.elementAuditableNorme.searchTerm = "";
    }
  }
});

export const {
  setSelectedNorme,
  setSearchTerm,
  setElementsDisponibles,
  setElementsAssocies,
  setSelectedDisponibles,
  setSelectedAssocies,
  setPaginationModel,
  moveElementsToAssocies,
  moveElementToDisponibles,
  resetSelections,
  clearSearchTerm
} = auditsInspectionsSlice.actions;

export default auditsInspectionsSlice.reducer;